import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ChevronDownIcon, ChevronUpIcon, SelectBox, Text } from '@mercai/clever'

import { SaleOrderCardProps } from './sale-order-card.type'

import styles from './sale-order-card.module.css'

export const SaleOrderCard = ({
  value,
  onChange,
  saleOrder,
  hasError = false,
}: SaleOrderCardProps) => {
  const [more, setMore] = useState(false)
  const { t } = useTranslation('componentSelectSaleOrdersForm')

  return (
    <SelectBox
      value={value}
      onChange={onChange}
      title={`#${saleOrder.reference}`}
      hasError={hasError}
      isMultiple={true}
    >
      {saleOrder?.items?.map((item, index) => {
        if (!more && index > 4) return null

        const title =
          item?.catalogProduct?.attributes?.title ||
          item?.nonCatalogProduct?.description

        return (
          <div
            className={styles['sale-order-card-item']}
            key={item?.uuid}
            onClick={() => setMore(!more)}
          >
            <Text
              variant="text-base"
              className={styles['sale-order-card-item-title']}
            >
              {title}
            </Text>

            <Text
              variant="text-base"
              className={styles['sale-order-card-item-quantity']}
            >
              {item?.quantity} kg
            </Text>
          </div>
        )
      })}

      {saleOrder?.items?.length > 4 && (
        <span
          className={styles['sale-order-card-item-more']}
          onClick={(e) => {
            e.stopPropagation()
            setMore(!more)
          }}
        >
          {more ? (
            <>
              {t('showLess')} <ChevronUpIcon />
            </>
          ) : (
            <>
              {t('showMore')}
              <ChevronDownIcon />
            </>
          )}
        </span>
      )}
    </SelectBox>
  )
}
